export enum ShipmentConsignmentErrorCodes {
  "INVALID_EXPORT_REASON" = "INVALID_EXPORT_REASON",
  "INVALID_EMAIL" = "INVALID_EMAIL",
  "INVALID_COUNTRY" = "INVALID_COUNTRY",
  "INVALID_ZIP" = "INVALID_ZIP",
}
